import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Form, Button, Input, InputNumber, message, Checkbox, Modal, Row, Col } from 'antd';
import styles from './sign.module.css';
import { signLab, modeList } from '@/api/api';
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 12 },
};
const formItemLayout1 = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
};
const formTailLayout = {
    wrapperCol: { span: 8, offset: 6 },
};
class SignLab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitLoading: false,
            checkedList: [],
            modeList: [],
            indeterminate: true,
            checkedIds: [],
            checkAll: false,
        };
        this.signSubmit = this.signSubmit.bind(this)
        this.userSubmit = this.userSubmit.bind(this)
        this.getMode = this.getMode.bind(this)
        this.onCheckAllChange = this.onCheckAllChange.bind(this)
    }

    componentDidMount() {
        this.getMode();
    }

    onChange = checkedList => {
        console.log(checkedList);
        this.setState({
            checkedList,
            indeterminate: !!checkedList.length && checkedList.length < this.state.modeList.length,
            checkAll: checkedList.length === this.state.modeList.length
        });
    };

    onCheckAllChange = e => {
        this.setState({
            checkedList: e.target.checked ? this.state.checkedIds : [],
            indeterminate: false,
            checkAll: e.target.checked,
        });
    };

    signSubmit = (e) => {
        const that = this;
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                console.log(err)
                message.warning("表单有未填写的必填项目，请填写后提交！")
                return
            };
            this.userSubmit(values)
        });
    }

    // 注册请求
    userSubmit(values) {
        const that = this;
        that.setState({
            sureLoading: true
        });
        var modes = '';
        if (that.state.checkAll) {
            modes = '0';
        }
        else {
            modes = that.state.checkedList.join(',')
        }
        let params = Object.assign({}, values, {
            source: 1,
            modes: modes
        })
        console.log(params);
        signLab(params, res => {
            console.log(res);
            // console.log(err);
            that.setState({
                sureLoading: false
            });
            if (res.statusCode === 1000) {
                that.props.setValue('signScs', res);
                that.props.setValue('modalVisible', false)
            } else {
                message.warning(res.message)
            }
        }, err => {
            that.setState({
                sureLoading: false
            });
            console.log(err)
            // message.error('提交失败')
            Modal.error({
                content: '提交失败',
            });
        })
    }

    // 获取注册模块
    getMode() {
        const that = this;

        modeList({}, res => {
            console.log(res);
            // console.log(err);
            that.setState({
                sureLoading: false
            });
            if (res.statusCode === 1000) {
                var checkedIds = [];
                for (var i = 0; i < res.modeList.length; i++) {
                    checkedIds.push(res.modeList[i].id)
                }
                that.setState({
                    checkedIds,
                    modeList: res.modeList
                });
            } else {
                message.warning(res.message)
            }
        }, err => {
            that.setState({
                sureLoading: false
            });
            console.log(err)
            // message.error('获取失败')
            Modal.error({
                content: '获取失败',
            });
        })
    }

    render() {
        const { submitLoading } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (
            <Form onSubmit={this.signSubmit} className={styles.sign_form}>
                <Row className='laboratoryLogin'>
                    <Col span={12}>
                        <FormItem label="实验室名称" {...formItemLayout}>
                            {getFieldDecorator('labName', {
                                rules: [
                                    { required: true, message: '请输入实验室名称' }, { max: 30, message: '最大输入30个字' }
                                ],
                                validateTrigger: 'onBlur',
                            })(
                                <Input
                                    placeholder="请输入实验室名称"
                                    size='middle'
                                    autoComplete="off" disableautocomplete='true'
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="联系人" {...formItemLayout}>
                            {getFieldDecorator('linkName', {
                                rules: [
                                    { required: true, message: '请输入联系人姓名' }, { max: 10, message: '最大输入10个字' }
                                ],
                                validateTrigger: 'onBlur',
                            })(
                                <Input
                                    placeholder="请输入联系人"
                                    size='middle'
                                    autoComplete="off" disableautocomplete='true'
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="电话" {...formItemLayout}>
                            {getFieldDecorator('linkPhone', {
                                rules: [
                                    { required: true, message: '请输入联系电话' },
                                    { max: 11, patern: /^1[34578]\d{9}$/, message: '请输入正确的手机号码!' }
                                ],
                                validateTrigger: 'onBlur',
                            })(
                                <Input
                                    placeholder="请输入联系电话"
                                    size='middle'
                                    autoComplete="off" disableautocomplete='true'
                                />
                            )}
                        </FormItem>

                    </Col>
                    <Col span={12}>
                        <FormItem label="QQ" {...formItemLayout}>
                            {getFieldDecorator('linkQQ', {
                                rules: [
                                    { required: true, message: '请输入联系QQ' }, { pattern: /^\d{5,11}$/, message: '请输入5-11位的QQ数' }
                                ],
                                validateTrigger: 'onBlur',
                            })(
                                <Input
                                    placeholder="请输入联系QQ"
                                    size='middle'
                                    autoComplete="off" disableautocomplete='true'
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="邮箱" {...formItemLayout}>
                            {getFieldDecorator('linkEmail', {
                                validateTrigger: 'onBlur',
                            })(
                                <Input
                                    placeholder="请输入联系邮箱"
                                    size='middle'
                                    autoComplete="off" disableautocomplete='true'
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="机构名称" {...formItemLayout}>
                            {getFieldDecorator('orgName')(
                                <Input
                                    placeholder="请输入所属机构名称"
                                    size='middle'
                                    autoComplete="off" disableautocomplete='true'
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="地址" {...formItemLayout}>
                            {getFieldDecorator('labAddress')(
                                <Input
                                    placeholder="请输入实验室详细地址"
                                    size='middle'
                                    autoComplete="off" disableautocomplete='true'
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="账号数" {...formItemLayout}>
                            {getFieldDecorator('peopleNum', {
                                rules: [
                                    { patern: /^\d+$/, message: '请输入实验开通账号数!' }
                                ],
                                validateTrigger: 'onBlur',
                            })(
                                <InputNumber
                                    placeholder="请输入开通账号数"
                                    size='middle'
                                    style={{ width: "179px" }}
                                    autoComplete="off" disableautocomplete='true'
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="登录名" {...formItemLayout}>
                            {getFieldDecorator('userName', {
                                rules: [{ min: 4, message: '输入登录名不少于四位' }],
                                validateTrigger: 'onBlur',
                            })(
                                <Input
                                    placeholder="请输入管理用户登录名"
                                    size='middle'
                                    autoComplete="off" disableautocomplete='true'
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem label="密码" {...formItemLayout}>
                            {getFieldDecorator('pwd', {
                                rules: [{ min: 5, max: 16, message: '5-16个字符' }],
                                validateTrigger: 'onBlur',
                            })(
                                <Input
                                    placeholder="请输入管理用户登录密码"
                                    size='middle'
                                    autoComplete="off" disableautocomplete='true'
                                />
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem label="功能模块" {...formItemLayout1}>
                            {getFieldDecorator('modes', {
                                validateTrigger: 'onBlur',
                            })(
                                <div>
                                    <div>
                                        <Checkbox
                                            onChange={this.onCheckAllChange}
                                            checked={this.state.checkAll}
                                        >
                                            所有功能
                            </Checkbox>
                                    </div>
                                    <CheckboxGroup
                                        options={this.state.modeList}
                                        value={this.state.checkedList}
                                        onChange={this.onChange}
                                    />
                                </div>
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem className={`${styles.login_btns} tc`}>
                            <Button htmlType="submit" type="primary" size="middle" loading={submitLoading}>提交</Button>
                            <Button size="middle" className="ml20" onClick={() => this.props.setValue('modalVisible', false)}>取消</Button>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        )
    }
}

export default Form.create({})(SignLab);
